import { AssignOnCallRequest } from '~/domain/usecases/onCallRequest/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteAssignOnCallRequest implements AssignOnCallRequest {
  private readonly url: string;

  private readonly httpClient: HttpClient<AssignOnCallRequest.Model>;

  constructor(url: string, httClient: HttpClient<AssignOnCallRequest.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  assign = async (
    params: AssignOnCallRequest.Params,
  ): Promise<AssignOnCallRequest.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{onCallId}', params.onCallId.toString())
        .replace('{specialistId}', params.specialistId.toString())
        .replace('{requestId}', params.requestId.toString()),
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
